<form class="form-signin mt-5" #loginForm="ngForm" (ngSubmit)="onSubmit()">
    <h1 class="mb-3 font-weight-normal">{{'LOGIN.title' | translate}}</h1>
    <div class="form-floating mb-3">
        <input type="text" class="form-control form-control-sm" name="email" id="email"
            placeholder="{{'LOGIN.usernameEmailLabel' | translate}}" ngModel required />
        <label>{{'LOGIN.usernameEmailLabel' | translate}}</label>
    </div>
    <div class="form-floating mb-3">
        <input type="password" class="form-control form-control-sm" name="password" id="password"
            placeholder="{{'LOGIN.passwordLabel' | translate}}" ngModel required />
        <label>{{'LOGIN.passwordLabel' | translate}}</label>
    </div>
    <p class="text-danger" *ngIf="authError">{{'LOGIN.authError'| translate}}</p>
    <!-- <div class="form-group">
        <label>{{'LOGIN.usernameEmailLabel' | translate}}</label>
        <input type="text" class="form-control" name="email" id="email"
            placeholder="{{'LOGIN.usernameEmailLabel' | translate}}" ngModel required />
        <p class="text-danger" *ngIf="authError">{{'LOGIN.authError'| translate}}</p>
    </div>
    <div class="form-group">
        <label>{{'LOGIN.passwordLabel' | translate}}</label>
        <input type="password" class="form-control" name="password" id="password"
            placeholder="{{'LOGIN.passwordLabel' | translate}}" ngModel required />
    </div> -->
    <button class="btn btn-primary btn-block" type="submit">{{'LOGIN.loginButton' | translate}}</button>
    <!-- <p class="mt-5 mb-3 text-muted text-center">© 2017-2020</p> -->
</form>
<div class="minimalResolutionError">
  {{'LOGIN.minimalResolutionError' | translate}}
</div>
